import {BaseModel} from '../../_base/crud';

export class Role extends BaseModel {
	id: string;
	title: string;
	description: string;
	permissions: string[];
	isCoreRole: boolean = false;

	clear(): void {
		this.id = undefined;
		this.title = '';
		this.description = '';
		this.permissions = [];
		this.isCoreRole = false;
	}
}
